module.exports = __webpack_public_path__ + "static/media/dochilove03.971ed658.jpg";